<ng-template #itemTemplate let-item>
	<div class="flex flex-col">
		<span>{{ item?.value?.accountName }}</span>
		<span class="text-grey text-xs">{{ item?.value?.description }}</span>
	</div>
</ng-template>

<form
	#changePasswordForm="ngForm"
	(ngSubmit)="onSubmit(changePasswordForm)"
	class="flex flex-1 flex-col justify-center items-center w-full mt-10 gap-2"
>
	<app-dropdown
		label="Account name"
		class="w-full"
		[itemGroups]="[{ items: accountNameOptions, template: itemTemplate }]"
		[required]="true"
		[value]="form_accountName"
		(onSelect)="onAccountNameSelected($event)"
		[testHook]="testHooks.AccountNameDropdown"
	></app-dropdown>

	<app-input
		label="Username"
		class="w-full"
		label="Username"
		[submitted]="submitted"
		[required]="true"
		placeholder="Username"
		[(ngModel)]="form_username"
		name="username"
		[testHook]="testHooks.Username"
	></app-input>

	<app-input
		label="Old password"
		class="w-full"
		type="password"
		[submitted]="submitted"
		[required]="true"
		placeholder="Old Password"
		autocomplete="current-password"
		[(ngModel)]="form_password_old"
		[name]="FORM_VALUES.PASSWORD"
		[testHook]="testHooks.OldPassword"
	></app-input>

	<app-input
		label="New password"
		class="w-full"
		type="password"
		[submitted]="submitted"
		[required]="true"
		placeholder="New Password"
		autocomplete="new-password"
		[(ngModel)]="form_password_new"
		name="password_new"
		[testHook]="testHooks.NewPassword"
	></app-input>

	<div *ngIf="error" class="text-center" [@openClose]>
		<atomic-message-bar type="error" [testHook]="testHooks.MessageBar">{{
			error
		}}</atomic-message-bar>
	</div>

	<div class="flex mt-11 w-full justify-between">
		<app-button
			btn="border"
			(click)="cancel()"
			[testHook]="testHooks.CancelButton"
			>Cancel</app-button
		>
		<app-button
			[loading]="loading"
			type="submit"
			[testHook]="testHooks.UpdateButton"
			>Update</app-button
		>
	</div>
</form>
